// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1rdl3","head":"Table_head__XbVns","col":"Table_col__1yzr9"};